var classList = require('dom-classlist');
var pubsub = require('pubsub');

var homeAnim = require('partials/home-animation');
var SVGAnims = require('partials/svg-animations');

var BlocT1 = require('partials/blocT1')
var BlocT2 = require('partials/blocT2')
var BlocT3 = require('partials/blocT3')

module.exports = function () {
    var _rub = document.querySelector('.b4s3_home')
    homeAnim();
    SVGAnims();

    // blocs init
    var _blocs = document.querySelectorAll('.bloc');
    Array.prototype.forEach.call(_blocs, function(el){ 
        if(classList(el).contains('T1')) BlocT1(el);
        if(classList(el).contains('T2')) BlocT2(el);
        if(classList(el).contains('T3')) BlocT3(el);
    });
}
